export default __webpack_public_path__ + "static/media/ToyotaType-Regular.5fe4d2fe.otf";